import * as React from 'react'
import Spinner from '../../components/Spinner'
import { emailValidate } from '../../utils'
import EditUserEmailPassword from './EditUserEmailPassword'
import { Redirect } from 'react-router-dom'
import { ScaleUploadImg } from '../../components/ScaleUploadImg'


class ManageUserDetailScreen extends React.Component {

  state = this.props.location.user


  componentWillReceiveProps(nextProps) {
    const { message } = nextProps.app
    if( message.length>0 && message!=='{ok}' )
      setTimeout( () => { this.props.appMessage('') }, 6000)
    else if( message==='{ok}' ) {
      this.props.appMessage('')
      this.props.history.goBack()
    }
  }
  

  renderInput = ({ fieldName, value, label, secure=false }) => {
    return (
      <div>
        <label htmlFor="exampleInputEmail1">{label}</label>
        <input 
          type={secure ? 'password' : 'text'} 
          className="form-control" 
          placeholder={label} 
          onChange={event=>this.setState({ [fieldName]: event.target.value })}
          defaultValue={value}
        />
      </div>
    )
  }

  renderTextarea = ({ fieldName, value, label }) => {
    return (
      <div>
        <label htmlFor="exampleInputEmail1">{label}</label>
        <textarea 
          className="form-control" 
          placeholder={label} 
          onChange={event=>this.setState({ [fieldName]: event.target.value })}
          defaultValue={value ? value.replace(/<br\s*[/]?>( |)/gi, "\n") : ''} 
        ></textarea>
      </div>
    )
  }

  renderEmailPass() {
    const { email, pass, pass2 } = this.state
    return (
    <React.Fragment>
      {this.renderInput({fieldName: 'email', value: email, label: 'Adres email'})}
      {this.renderInput({fieldName: 'pass', value: pass, label: 'Hasło', secure: true})}
      {this.renderInput({fieldName: 'pass2', value: pass2, label: 'Powtórz hasło', secure: true})}
      { pass && pass.length && pass2 && pass2.length && pass!==pass2 ? <div className="alert alert-danger small">Podane hasła nie są identyczne</div> : null}
      { pass && pass.length<6 && pass2 && pass2.length<6 ? <div className="alert alert-danger small">Hasło musi mieć min. 6 znaków</div> : null}
    </React.Fragment>
    )
  }

  renderRestaurant() {
    const { id, name, phone, website, address, description } = this.state
    return (
      <form>
        {!id ? this.renderEmailPass() : null}
        {this.renderInput({fieldName: 'name', value: name, label: 'Nazwa'})}
        {this.renderInput({fieldName: 'phone', value: phone, label: 'Telefon'})}
        {this.renderInput({fieldName: 'website', value: website, label: 'Strona internetowa'})}
        {this.renderTextarea({fieldName: 'address', value: address, label: 'Adres'})}
        {this.renderTextarea({fieldName: 'description', value: description, label: 'Opis'})}
      </form>
    )
  }
  
  rotateOption = 1;
  resetOrientationHandler() {
    if( this.rotateOption>=8 ) this.rotateOption=1
    else this.rotateOption += 1

    this.resetOrientation(this.state.photo, this.rotateOption, (res)=> { this.setState({ photo: res }) } )
  }


  resetOrientation(srcBase64, srcOrientation, callback) {
    var img = new Image();	
  
    img.onload = function() {
      var width = img.width,
          height = img.height,
          canvas = document.createElement('canvas'),
          ctx = canvas.getContext("2d");
      
      // set proper canvas dimensions before transform & export
      if (4 < srcOrientation && srcOrientation < 9) {
        canvas.width = height;
        canvas.height = width;
      } else {
        canvas.width = width;
        canvas.height = height;
      }
    
      // transform context before drawing image
      switch (srcOrientation) {
        case 2: ctx.transform(-1, 0, 0, 1, width, 0); break;
        case 3: ctx.transform(-1, 0, 0, -1, width, height ); break;
        case 4: ctx.transform(1, 0, 0, -1, 0, height ); break;
        case 5: ctx.transform(0, 1, 1, 0, 0, 0); break;
        case 6: ctx.transform(0, 1, -1, 0, height , 0); break;
        case 7: ctx.transform(0, -1, -1, 0, height , width); break;
        case 8: ctx.transform(0, -1, 1, 0, 0, width); break;
        default: break;
      }
  
      // draw image
      ctx.drawImage(img, 0, 0);
  
      // export base64
      callback(canvas.toDataURL());
    };
  
    img.src = srcBase64;
  }


  renderFisherman() {
    const { id, firstName, lastName, phone, shipNo } = this.state
    return (
      <form>
        {!id ? this.renderEmailPass() : null}
        {this.renderInput({fieldName: 'firstName', value: firstName, label: 'Imię'})}
        {this.renderInput({fieldName: 'lastName', value: lastName, label: 'Nazwisko'})}
        {this.renderInput({fieldName: 'phone', value: phone, label: 'Telefon'})}
        {this.renderInput({fieldName: 'shipNo', value: shipNo, label: 'Numer kutra'})}

        <div className="my-3">
          <label className="w-100">Zdjęcie rybaka</label>
          {this.state.photo && <img alt="" src={this.state.photo} /> }
          {this.state.photo && <img alt="" style={{ width: '50px' }} src={require('../../assets/rotate.png')} onClick={ () => this.resetOrientationHandler() } /> }
          <ScaleUploadImg maxHeight={300} maxWidth={300} onChangePhoto={ (photo) => this.setState({ photo: photo }) } />
        </div>
      </form>
    )
  }

  addOrUpdateUser = () => {
    if( this.state.id)
      this.props.updateUserData(this.state)
    else
      this.props.addNewUser(this.state)
  }

  isDisabled() {
    const { pass, pass2, email, firstName, lastName, name, type } = this.state

    if( this.state.id ) return false
    else if( !pass || !pass.length || !pass2 || !pass2.length || pass!==pass2 ) return true
    else if ( !email || !email.length || !emailValidate(email) ) return true
    else if( type==='fisherman' && (!firstName || !lastName) ) return true
    else if( type==='restaurant' && !name ) return true
    else return false
  }

  updateUsersData(email, password) {
    const userId = this.props.location.user.id,
          adminId = this.props.login.id
    this.props.updateUserEmailPassword(email, password, userId, adminId)
  }

  deleteUserWithAlert = () => {
    const userId = this.props.location.user.id,
          adminId = this.props.login.id
    
    if (window.confirm('Potwierdź usunięcie'))
      this.props.deleteUser(userId, adminId)
  }

  render() {
    if( !this.state ) return <Redirect to="/manageapp" />
    if( this.props.app.loading ) return <Spinner />
    return (
      <div>
        { this.props.app.message.length>0 ? <div className="alert alert-danger">{this.props.app.message}</div> : null}

        { this.state.type === 'fisherman' ?  this.renderFisherman() : this.renderRestaurant() }
        
        <button
          className="btn btn-primary mt-2"
          disabled={ this.isDisabled() }
          onClick={ this.addOrUpdateUser }
          type="submit"
        >{this.state.id ? 'Aktualizuj' : 'Dodaj'}
        </button>

        { this.state.id && <EditUserEmailPassword 
                        updateUserEmailPassword={(email, password) => this.updateUsersData(email, password)} 
                        email={this.state.email}
                        />}
        { this.state.id && <button
          className="btn btn-danger mt-3 btn-sm"
          onClick={ this.deleteUserWithAlert }
        >Usuń 
        </button> }


      </div>
    )
  }
}



export default ManageUserDetailScreen



// WEBPACK FOOTER //
// ./src/screens/ManageUsers/ManageUserDetailScreen.js